import { useContext } from "react";
import { PurchaseOrderDashboardContext } from "./PurchaseOrder.provider";

export function usePurchaseOrderDashboardContext() {
  const context = useContext(PurchaseOrderDashboardContext); // Use o contexto diretamente

  if (!context) {
    throw new Error(
      "usePieceDashboardContext deve ser utilizado apenas dentro de PurchaseOrderDashboardProvider"
    );
  }

  return context;
}